import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'autobind-decorator';
import _ from 'lodash';
import ClientAnalytics from '../analytics/ClientAnalytics';
import {getFingerprints} from '../fingerprint/FingerprintUtils';
import {getDeviceType} from '../utils/BrowserUtils';
import * as RedirectConst from '../const/RedirectConst';
import RedirectPreferenceApi from '../api/RedirectPreferenceApi';
import * as RedirectPreferenceUtils from '../utils/RedirectPreferenceUtils';
import {injectHtml} from '../utils/DomUtils';

export default class SimpleRedirect extends React.PureComponent {
  componentDidMount() {
    this.appendDestinationRedirectTrackingCode();
    getFingerprints();
    setTimeout(this.onRedirect, 500);
  }

  @autobind
  redirect() {
    const {destination: {url}} = this.props;
    if (url) {
      window.location.replace(url);
    }
  }

  @autobind
  onRedirect() {
    getFingerprints(async () => {
      try {
        await this.trackRedirection();
      } finally {
        this.setFingerprintRedirectPreference(() => {
          this.redirect();
        });
      }
    });
  }

  @autobind
  setFingerprintRedirectPreference(cb) {
    const {campaignId, destination} = this.props;

    if (campaignId && this.isFingerprintRedirectActive()) {
      let preference = null;
      getFingerprints(async ({fingerprint, fingerprint2}) => {
        try {
          try {
            preference = await RedirectPreferenceApi.get(fingerprint2, fingerprint);
          } catch (e) {
            console.log(e);
          }

          if (!preference) {
            preference = RedirectPreferenceUtils.getEmpty();
          }
          const updated = RedirectPreferenceUtils.setDestination(preference, campaignId, destination.name, destination.kind);
          if (!_.isEqual(updated, preference)) {
            await RedirectPreferenceApi.set({fingerprint, fingerprint2}, updated);
          }
        } finally {
        cb();
        }
      });
    } else {
      cb();
    }
  }

  isFingerprintRedirectActive() {
    return !_.get(this.props, 'cardProps.campaign.isFingerprintRedirectDisabled');
  }

  @autobind
  async trackRedirection() {
    const {redirectType, destination, cardId, campaignId} = this.props;
    await ClientAnalytics.sendCardRedirect(
      cardId,
      campaignId,
      RedirectConst.redirectActions.auto,
      redirectType,
      destination.url,
      getDeviceType(),
      destination.name
    );
  }

  render() {
    return (
      this.renderDestinationClickTrackingCodeContainer()
    );
  }

  renderDestinationClickTrackingCodeContainer() {
    return (
      <span id="tracking-code"
            style={{position: 'absolute', bottom: '0', visibility: 'hidden'}}
            ref={(node) => {
              this.destinationTrackingCodeContainer = node;
            }}
      />
    );
  }

  appendDestinationRedirectTrackingCode() {
    if (this.destinationTrackingCodeContainer) {
      const {destination} = this.props;
      if (destination.trackingCode) {
        const wrapper = document.createElement('span');
        this.destinationTrackingCodeContainer.appendChild(wrapper);
        injectHtml(wrapper, destination.trackingCode);
      }
    }
  }
}

SimpleRedirect.propTypes = {
  destination: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired
};
